// web/src/features/profile/hooks/useResendFamilyContact.ts
//
// GET mutation for re-sending a pending family invitation. Triggered on click
// (never auto-runs). On success, invalidates the affected player's family-list
// cache so any status change is reflected. Web mirror of the mobile hook.
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import {
  resendFamilyContact,
  type ResendFamilyContactInput,
  type ResendFamilyContactResponse,
} from '@sportninja/common/services/player/resendFamilyContact'

export const useResendFamilyContact = () => {
  const queryClient = useQueryClient()
  return useMutation<
    ResendFamilyContactResponse,
    Error,
    ResendFamilyContactInput
  >({
    mutationFn: resendFamilyContact,
    // Override the global mutations.retry=1 default (see queryClient config).
    retry: 0,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.playerFamily.byPlayer(variables.playerId),
      })
    },
  })
}
